export function useCurrency() {
    const rupiahFormat = (nominal: any) => {
        return new Intl.NumberFormat('id-ID', {
            style: 'currency',
            currency: 'IDR',
            maximumFractionDigits: 0,
    }).format(nominal)
    }

    return { rupiahFormat }
}
